import { toggleList } from '@sketchnote/slate-plugins';
import {
  ELEMENT_UL,
  getListItemEntry,
  getPreventDefaultHandler,
  ToolbarButtonProps,
  usePlateEditorState,
} from '@udecode/plate';
import * as React from 'react';

import { ToolbarButton } from '../toolbar-button';

export interface ToolbarElementProps extends Omit<ToolbarButtonProps, 'active' | 'onClick'> {
  type: string;
  inactiveType?: string;
  icon: React.ReactNode;
  btnRef?: any;
  onSelect?: () => void;
}

export const ToolbarList = ({
  type = ELEMENT_UL,
  icon,
  label,
  tooltip,
  btnRef,
  onSelect,
  ...props
}: ToolbarElementProps & { type?: string }): JSX.Element => {
  const editor = usePlateEditorState();

  const res = !!editor?.selection && getListItemEntry(editor);
  return (
    <ToolbarButton
      active={!!res && res.list[0].type === type}
      icon={icon}
      label={label}
      tooltip={tooltip}
      btnRef={btnRef}
      onMouseDown={editor && getPreventDefaultHandler(toggleList, editor, { type })}
      onClick={onSelect}
      {...props}
    />
  );
};
